import { h } from 'preact';
import cx from 'classnames';

import style from './style.less';


/** A placeholder used for page demos
 */
export const Placeholder = ({ id, label, type }) =>
	(
		<div id={id} class={style.placeholderWrapper}>
			<div class={cx(style.placeholder, style[type])}>
				{label}
			</div>
		</div>
	);
